import { TrashIcon } from '@ui/kit/icons';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';

const okLabelCls = "_ibqo9jgei";
const makeDeleteRevisionConfirmConfig = revision => ({
  heading: `Vil du slette versionen ‘${revision.name}’?`,
  body: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("p", {
      children: "Bem\xE6rk, at denne handling ikke kan fortrydes."
    }), /*#__PURE__*/jsx("p", {
      children: "Hvis du sletter en version, som du allerede har delt, vil versionen ikke l\xE6ngere v\xE6re tilg\xE6ngelig for modtagerne."
    })]
  }),
  labels: {
    ok: /*#__PURE__*/jsxs("span", {
      className: okLabelCls,
      children: [/*#__PURE__*/jsx(TrashIcon, {
        height: "18"
      }), "Slet version"]
    })
  }
});

export { makeDeleteRevisionConfirmConfig };
import "./delete.linaria.module.css";
//# sourceMappingURL=delete.js.map
